import React from 'react';

const clauses = [
  {
    title: 'Artikel 1 — Opdracht en Deliverables',
    text: 'Opdrachtnemer verbindt zich ertoe de overeengekomen werkzaamheden uit te voeren conform de specificaties zoals beschreven in de bijlage bij deze overeenkomst. De opdracht omvat uitsluitend de werkzaamheden zoals expliciet omschreven; aanvullende werkzaamheden worden schriftelijk overeengekomen en afzonderlijk gefactureerd.',
  },
  {
    title: 'Artikel 2 — Vergoeding en Betaling',
    text: 'Opdrachtgever betaalt Opdrachtnemer een vergoeding van € [bedrag], exclusief BTW (21% NL / 21% BE). Facturen dienen te worden voldaan binnen 30 dagen na factuurdatum. Bij overschrijding van de betalingstermijn is Opdrachtgever van rechtswege in verzuim en is een vertragingsrente verschuldigd conform het toepasselijk recht.',
  },
  {
    title: 'Artikel 3 — Toepasselijk Recht en Bevoegde Rechter',
    text: 'Op deze overeenkomst is [Belgisch / Nederlands] recht van toepassing. Alle geschillen die voortvloeien uit of verband houden met deze overeenkomst worden voorgelegd aan de bevoegde rechter te [Brussel / Amsterdam], tenzij partijen schriftelijk een andere wijze van geschillenbeslechting overeenkomen.',
  },
  {
    title: 'Artikel 4 — Intellectueel Eigendom',
    text: 'Na volledige betaling van de overeengekomen vergoeding draagt Opdrachtnemer alle intellectuele eigendomsrechten op de in het kader van deze overeenkomst ontwikkelde werken over aan Opdrachtgever. Deze overdracht geldt voor alle landen waar intellectuele eigendomsrechten kunnen worden gevestigd, inclusief België en Nederland.',
  },
];

const BeneluxClauses = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Voorbeeldclausules voor de Benelux</h2>
    <p className="text-gray-600 mb-6">Onderstaande clausules zijn neutraal opgesteld en toepasbaar voor zowel Belgische als Nederlandse freelancers:</p>
    <div className="space-y-4">
      {clauses?.map((clause, i) => (
        <div key={i} className="border border-gray-200 rounded-xl p-6 bg-white shadow-sm">
          <h3 className="font-bold text-[#2F4E6F] mb-3">{clause?.title}</h3>
          <p className="text-gray-700 leading-relaxed text-sm font-mono bg-gray-50 p-4 rounded-lg">{clause?.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default BeneluxClauses;
